import { useEffect, useEffectEvent, useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import { ErrorLike } from '@apollo/client';

import {
    IOverviewPageOffersQueryVariables,
    OverviewPageOfferEventsDocument,
} from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

export const useOfferEventOverviewList = (
    queryVariables: IOverviewPageOffersQueryVariables
) => {
    const { showApolloError } = useApolloError();
    const { loading, data, error } = useQuery(OverviewPageOfferEventsDocument, {
        variables: queryVariables,
        notifyOnNetworkStatusChange: true,
    });

    const onError = useEffectEvent((error: ErrorLike) => {
        showApolloError(error);
    });

    useEffect(() => {
        if (error) {
            onError(error);
        }
    }, [error]);

    const {
        count: offerEventsCount,
        edges,
        extraCategories: extraCategoryQueryFilters,
    } = data?.paginatedOfferEvents || {};

    const offerEvents = useMemo(
        () => edges?.map((edge) => edge?.node).filter(Boolean) || [],
        [edges]
    );

    const extraCategoryFilters = useMemo(
        () => extraCategoryQueryFilters?.filter(Boolean) || [],
        [extraCategoryQueryFilters]
    );

    return {
        offerEvents,
        offerEventsCount,
        loading,
        extraCategoryQueryFilters: extraCategoryFilters,
    };
};
